import { SeTaskState } from './state';
import { apiUrl } from '@/env';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { ISeTask, ISeOneTaskStat, ISeTasksStatData } from '@/interfaces/se-tasks';


export const mutations = {
  setSeTasks(state: SeTaskState, payload: ISeTask[]) {
    // добавляем флаг isExporting; его пока нет в PG
    // если isExporting = true, иконка загрузки файлов заблокирована
    payload.forEach((item) => {
      item.isExporting = state.se_tasks.find((task) => task.id === item.id)?.isExporting;
      item.isDownloading = state.se_tasks.find((task) => task.id === item.id)?.isDownloading;
      if (item.status === 'ACTIVE') {
        const taskActive = state.se_tasks.find((t) => t.id === item.id);
        if (taskActive && taskActive.stats) item.stats = taskActive.stats;
      }
      if (item.isExporting) item.status = 'EXPORT';
      else if (item.isDownloading) item.status = 'DOWNLOAD';
    });
    state.se_tasks = payload;
  },
  setSeTask(state: SeTaskState, payload: ISeTask) {

    // const newList: ISeTask[] = state.se_tasks.slice();
    // const index = newList.findIndex(item => item.id === payload.id);
    // if (index !== -1) {
    //     newList[index] = payload;
    //     state.se_tasks = newList;
    // };

    // самый быстрый вариант
    const newList: ISeTask[] = state.se_tasks.slice();
    for (let i = 0; i < newList.length; i++)
      if (newList[i].id === payload.id) {
        newList[i] = payload;
        break;
      }
    state.se_tasks = newList;
  },

  // изменяем флаг isExporting
  setSeTaskIsExporting(state: SeTaskState, payload: { id: number, isExporting: boolean}) {
      const task = state.se_tasks.find((item: ISeTask) => item.id === payload.id);
      if (task) task.isExporting = payload.isExporting;
  },

  // изменяем флаг isDownloading
  setSeTaskIsDownloading(state: SeTaskState, payload: { id: number, isDownloading: boolean}) {
      const task = state.se_tasks.find((item: ISeTask) => item.id === payload.id);
      if (task) task.isDownloading = payload.isDownloading;
  },

  setSeTaskStatus(state: SeTaskState, payload: { id: number, status: string}) {
      const task = state.se_tasks.find((item: ISeTask) => item.id === payload.id);
      if (task) task.status = payload.status;
  },

  setSeTasksStat(state: SeTaskState, payload: ISeTasksStatData) {
    if (payload.tasks)
      state.se_tasks = state.se_tasks.map((t: ISeTask) => {
        const taskStat = payload.tasks.find((s: ISeOneTaskStat) =>  t.id === s.task_id);
        if (taskStat) {
          t.status = taskStat.status;
          t.datetime_end = taskStat.datetime_end;

          const yandex_ru_prev = t.stats?.yandex_ru_prev;
          const yandex_prev_time = t.stats?.yandex_prev_time;
          const google_prev = t.stats?.google_prev;
          const google_prev_time = t.stats?.google_prev_time;

          t.stats = taskStat.stats;

          // записыаем стартовые значения количества найденных данных и времени
          // для расчета времени до завершения парсинга
          if (t.stats) {
            t.stats.yandex_ru_prev = yandex_ru_prev;
            t.stats.yandex_prev_time = yandex_prev_time;
            t.stats.google_prev = google_prev;
            t.stats.google_prev_time = google_prev_time;

            const curTime = new Date();

            if (t.stats.yandex_ru > 0) {
              if (t.stats.yandex_ru_prev === undefined)
                t.stats.yandex_ru_prev = t.stats.yandex_ru;

              if (t.stats.yandex_prev_time === undefined)
                t.stats.yandex_prev_time = curTime;
            }

            if (t.stats.google > 0) {
              if (t.stats.google_prev === undefined)
                t.stats.google_prev = t.stats.google;

              if (t.stats.google_prev_time === undefined)
                t.stats.google_prev_time = curTime;
            }
          }

          if (taskStat.result)
            t.result = `${apiUrl}/api/v1/se-tasks/result/${taskStat.result}`;
        }
        return t;
      });
  },

};

const { commit } = getStoreAccessors<SeTaskState, State>('');

export const commitSetSeTask = commit(mutations.setSeTask);
export const commitSetSeTasks = commit(mutations.setSeTasks);
export const commitSetSeTasksStat = commit(mutations.setSeTasksStat);
export const commitSetSeTaskIsExporting = commit(mutations.setSeTaskIsExporting);
export const commitSetSeTaskIsDownloading = commit(mutations.setSeTaskIsDownloading);
export const commitSetSeTaskStatus = commit(mutations.setSeTaskStatus);
